// extracted by mini-css-extract-plugin
module.exports = {"landinpage":"LandingPage_landinpage__2VWWd"};